module.exports = __webpack_public_path__ + "img/head-bg.ff2c2003.png";